import { useQuery } from "@tanstack/react-query";
import { getOrgStructureAssignment } from "../../api/apiOrgStructureAssignments";
import i18next from "i18next";

export function useGetOrgStructureAssignment(id) {
    const { isLoading, data: assignment, error } = useQuery({
        queryKey: ["orgStructureAssignments", id, i18next.language],
        queryFn: () => getOrgStructureAssignment(id),
        enabled: !!id,
        retry: false,
    });
    return { isLoading, error, assignment };
}
